module.exports = __webpack_public_path__ + "static/media/icon-check.1b12ca33.svg";